import storage from './storage'

const DB_NAME = 'doutian-workspace'
const DB_VERSION = 1
const STORE_NAME = 'drafts'

let databasePromise = null

function openDatabase() {
  if (!('indexedDB' in window)) return Promise.reject(new Error('IndexedDB is unavailable'))
  if (databasePromise) return databasePromise

  databasePromise = new Promise((resolve, reject) => {
    const request = indexedDB.open(DB_NAME, DB_VERSION)
    request.onupgradeneeded = () => {
      const database = request.result
      if (!database.objectStoreNames.contains(STORE_NAME)) {
        database.createObjectStore(STORE_NAME)
      }
    }
    request.onsuccess = () => resolve(request.result)
    request.onerror = () => reject(request.error || new Error('Failed to open draft database'))
  })

  return databasePromise
}

async function runTransaction(mode, action) {
  const database = await openDatabase()
  return new Promise((resolve, reject) => {
    const transaction = database.transaction(STORE_NAME, mode)
    const store = transaction.objectStore(STORE_NAME)
    const request = action(store)
    let result
    request.onsuccess = () => {
      result = request.result
    }
    transaction.oncomplete = () => resolve(result)
    transaction.onerror = () => reject(transaction.error || new Error('Draft transaction failed'))
    transaction.onabort = () => reject(transaction.error || new Error('Draft transaction aborted'))
  })
}

function readLegacyDraft(key) {
  const raw = storage.get(key)
  if (!raw) return null
  try {
    return JSON.parse(raw)
  } catch {
    storage.remove(key)
    return null
  }
}

export async function getWorkspaceDraft(key) {
  try {
    const draft = await runTransaction('readonly', (store) => store.get(key))
    if (draft) return draft
  } catch {
    // Fall through to legacy storage for restricted/private browsers.
  }

  const legacyDraft = readLegacyDraft(key)
  if (legacyDraft) {
    await saveWorkspaceDraft(key, legacyDraft)
  }
  return legacyDraft
}

export async function saveWorkspaceDraft(key, draft) {
  try {
    await runTransaction('readwrite', (store) => store.put(draft, key))
    storage.remove(key)
    return true
  } catch {
    try {
      const serialized = JSON.stringify(draft)
      storage.set(key, serialized)
      return storage.get(key) === serialized
    } catch {
      return false
    }
  }
}

export async function removeWorkspaceDraft(key) {
  storage.remove(key)
  try {
    await runTransaction('readwrite', (store) => store.delete(key))
  } catch {
    // Legacy storage was still cleared even if IndexedDB is unavailable.
  }
}
